<template>
    <div class="rd">
        <div class="pagina">
            <div class="inlog-wrap">
                <form class="paneel inlog-kaart" novalidate @submit.prevent="handleLogin">
                    <img src="/x-cube-logo.png" alt="X-Cube" class="inlog-logo" />
                    <h1>Hub</h1>
                    <p class="muted" style="margin:0 0 8px">Log in to manage your bookings and X-Cubes.</p>

                    <div class="veld">
                        <label for="l-mail">Email</label>
                        <input
                            id="l-mail"
                            v-model.trim="email"
                            type="email"
                            autocomplete="username"
                            placeholder="you@example.com"
                            :aria-invalid="!!errors.email"
                            @input="errors.email = ''"
                        />
                        <span class="fout">{{ errors.email }}</span>
                    </div>

                    <div class="veld">
                        <label for="l-pw">Password</label>
                        <input
                            id="l-pw"
                            v-model="password"
                            type="password"
                            autocomplete="current-password"
                            :aria-invalid="!!errors.password"
                            @input="errors.password = ''"
                        />
                        <span class="fout">{{ errors.password }}</span>
                    </div>

                    <button class="btn btn-pink" type="submit" style="width:100%" :disabled="loading">
                        {{ loading ? "Logging in…" : "Log in" }}
                    </button>

                    <div class="inlog-links">
                        <router-link class="linkknop" to="/forgot-password">Forgot password?</router-link>
                        <router-link class="linkknop" to="/request-login-link">Email me a login link</router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Message } from "element-ui";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { login } from "../../api/rest";
import { isHubUser } from "../../helpers/auth";

const router = useRouter();

const email = ref("");
const password = ref("");
const loading = ref(false);
const errors = reactive({ email: "", password: "" });

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

function validate() {
    errors.email = !email.value
        ? "Enter your email address."
        : !EMAIL_RE.test(email.value)
          ? "This email address is missing an @ or a domain."
          : "";
    errors.password = password.value ? "" : "Enter your password.";
    return !errors.email && !errors.password;
}

const handleLogin = async () => {
    if (!validate()) {
        return;
    }
    try {
        loading.value = true;
        const user = await login({ identifier: email.value, password: password.value });

        if (!isHubUser(user)) {
            window.location.replace(import.meta.env.VITE_APP_MY_XCUBE_URL);
            return;
        }

        Message.success("Login successful");
        router.push({ name: "bookings" });
    } catch (error) {
        console.error("Login error:", error);
        Message.error("Login failed, please check your email and password");
    } finally {
        loading.value = false;
    }
};
</script>
